
import pcosInitialQuestions from './initial/questions';
import pcosFollowupQuestions from './followup/questions';

const pcosQuestions = [...pcosInitialQuestions, ...pcosFollowupQuestions];
export default pcosQuestions;

export type { PCOSInitialQuestionFieldAnswers } from './initial/questions';
export type { PCOSFollowupQuestionFieldAnswers } from './followup/questions';